import './i18n/i18n';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppProviders from "./app/providers/AppProviders";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
